import config from 'js/app/config';
import Logger from 'js/lib/log';

export default Logger({ level: config.log });
